<template>
  <div id="container">
    <div
      class="item-box-content"
      style="padding:10px 20px;">
      <div style="display: flex;justify-content: space-between;align-items: center">
        <div class="title-font-style">
          <span>其他票据税率设置</span>
        </div>
        <el-button
          type="primary"
          plain
          @click="onAddOrEditUnit(1)">新增
        </el-button>
      </div>
    </div>
    <div
      class="item-box-content"
      style="margin-bottom: 0;">
      <div :style="{height:tableHeight + 'px'}">
        <el-table
          border
          ref="tableRef"
          :data="list"
          :max-height="tableHeight"
          :header-cell-style="tableHeader"
          tooltip-effect="dark"
          v-loading="loadingTable"
          row-key="id"
          :default-sort="{prop: 'sort', order: 'ascending'}"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            prop="type"
            label="序号"
            type="index"
            width="100px"></el-table-column>
          <el-table-column
            prop="taxName"
            label="税种"
            align="left"
            width="100px"></el-table-column>
          <el-table-column
            prop="taxCount"
            label="税率">
            <template slot-scope="scope">{{(strip(scope.row.taxCount * 100))}}%</template>
          </el-table-column>
          <el-table-column
            prop
            label="操作"
            width="110px">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="onAddOrEditUnit(2,scope.row)">修改
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop
            label="是否启用"
            width="120px">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.flag"
                @change="updatestate(scope.row)"
                active-color="#276CFF"
              ></el-switch>

              <!-- isshow -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 20px;">
        <i
          class="el-icon-warning-outline"
          style="color:#D35E5E;font-size: 16px;vertical-align: -2px;padding-right: 6px;"></i>
        <span style="color:#D35E5E">提示：排序越靠前越方便选择，可以通过拖动调整顺序</span>
      </div>
    </div>
    <!-------------- 新增/更改税率信息 -------------->
    <add-tax-rate ref="addEditBrandRefs"></add-tax-rate>
  </div>
</template>

<script>
  import {
    gettaxRate,
    UpdatetaxRate,
    isEnable,
    orderTaxRateSort
  } from '@/api/system/rightsManagement'

  import { expressionList } from '@/components/utils/data'
  import addTaxRate from '../dialog/addTaxRate'
  import Sortable from 'sortablejs'
  import { isSuccess } from '@/util/tool'
  import NP from 'number-precision'

  var _this
  export default {
    components: {
      'add-tax-rate': addTaxRate
    },
    data () {
      return {
        queryParams: {},
        params: {},
        contractScreenCondition: [],
        expressionList: expressionList,
        loadingTable: false, // 列表loading
        list: [], // 列表数据
        pageSize: 3000, // 页数
        currentPage: 1, // 页码
        total: 0, // 列表总数
        value1: false,
        value2: true,
        accValues: [],
        tableHeight: window.innerHeight - 290
      }
    },
    mounted () {
      _this = this
      _this.getList()
      document.body.ondrop = function (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      this.rowDrop()
    },
    methods: {
      strip (val) {
        return NP.strip(val)
      },
      rowDrop () {
        const tbody = document.querySelector('.el-table__body-wrapper tbody')
        const _this = this
        Sortable.create(tbody, {
          sort: true,
          onEnd ({ newIndex, oldIndex }) {
            const currRow = _this.list.splice(oldIndex, 1)[0]
            _this.list.splice(newIndex, 0, currRow)
            _this.list.forEach((v, i) => {
              _this.$set(v, 'sort', i + 1)
            })
            _this.list = _this.list.map(item => {
              item.flag = Number(item.flag)
              return item
            })
            orderTaxRateSort({
              financeBillTaxSettingList: [..._this.list]
            }).then(res => {
              _this.$message({
                message: res.data.msg,
                type: res.data.code === 200 ? 'success' : 'error'
              })
            })
            _this.getList()
          }
        })
      },
      updatestate (row) {
        const { id, flag } = row
        isEnable(id, Number(flag)).then(res => {
          if (isSuccess(res)) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
          }
        })
      },
      getList: async () => {
        const { currentPage, pageSize } = _this
        const taxRate = await gettaxRate(currentPage, pageSize)
        _this.list = taxRate.data.obj.records
        _this.total = taxRate.data.obj.total
        _this.accValues = []
        _this.list.forEach((v, i) => {

          // v.taxCount = v.taxCount > 1 ? v.taxCount : parseFloat(v.taxCount.toString()) * 100
          _this.accValues.push(v.taxName)
          _this.$set(v, 'index', i + 1)
          _this.$set(v, 'flag', Boolean(v.flag))
          _this.$set(v, 'isshow', false)
        })

        _this.$refs.addEditBrandRefs.hasAccName = _this.accValues
      },
      // 新增税率信息窗口
      onAddOrEditUnit (type, row) {
        if (row) {
          let temp = JSON.parse(JSON.stringify(row))
          this.$refs.addEditBrandRefs.onInitialize(type, temp)
          return
        }
        this.$refs.addEditBrandRefs.onInitialize(type)
      },
      // 设置头部背景色
      tableHeader ({ rowIndex }) {
        return this.$tableHeader(rowIndex)
      },
      // 页数
      handleSizeChange (val) {
        this.pageSize = val
        this.getList()
      },
      // 页码
      handleCurrentChange (val) {
        this.currentPage = val
        this.getList()
      }
    }
  }
</script>

<style
  lang="scss"
  scoped>
  .search-style {
    padding: 10px 20px 10px 30px;
  }
</style>
